import { Link } from "react-router-dom";
import { Reveal } from "../Reveal";

// Like the printed quote pages: one sentence in giant type, the pink y in the corner.
export const QuotePage = ({ q }) => {
  if (!q?.text) return null;
  return (
    <section className="bg-cream border-y border-ink min-h-[75svh] lg:min-h-[100svh] flex flex-col justify-between px-5 sm:px-10 py-16 sm:py-20" data-testid="quote-page">
      <div className="max-w-[1440px] w-full mx-auto">
        <Reveal>
          <blockquote className="dz-type text-[clamp(2.2rem,6.4vw,6.8rem)] leading-[1.02] max-w-[1300px]" data-testid="quote-page-text">
            “{q.text}”
          </blockquote>
        </Reveal>
      </div>
      <div className="max-w-[1440px] w-full mx-auto flex items-end justify-between gap-6 mt-12">
        <span className="wordmark text-pink text-[clamp(6rem,14vw,13rem)] leading-[0.8]" aria-hidden="true">y</span>
        <Link to={`/article/${q.slug}`} className="kicker text-right max-w-xs border-b-2 border-pink pb-1 hover:text-pink transition-colors" data-testid="quote-page-link">
          From “{q.title.split(":")[0]}” →
        </Link>
      </div>
    </section>
  );
};
